/* src/app/modules/print-cards/components/cards/backgrounds/index-cards-3x5/miss-jones-card-stack-background/miss-jones-card-stack-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
}
:host .color-strip {
  background-color: #5da05d;
  position: absolute;
  width: 100%;
  height: 2.625rem;
}
:host .color-strip.on-perforated-paper {
  width: unset;
  height: 3.625rem;
  top: -1rem;
  left: -1rem;
  right: -1rem;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=miss-jones-card-stack-background.component.css.map */
